<template>
    <table class="table table-sm table-hover" id="stage_table">
        <thead class="thead-light">
            <tr>
                <th scope="col">#</th>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(option, index) in list" :key="index">
                <th scope="row" class="stage-cnt">{{ index + 1 }}</th>
                <td class="stage-id">{{ option.id }}</td>
                <td class="stage-name">{{ option.name }}</td>
                <td class="stage-actions text-right">
                    <button v-on:click="selectItem(option)" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
                    <button v-on:click="layoutItem(option)" class="btn btn-sm btn-secondary"><span class="fa fa-sitemap"></span></button>                                   
                    <button class="stage-edit-btn btn btn-sm btn-secondary" data-toggle="modal" data-target="#stageEditModal" :data-id="option.id"><i class="fa fa-edit"></i></button>                    
        <!--  <button v-on:click="editItem(option)" class="btn btn-sm btn-secondary"><i class="fa fa-edit"></i></button> -->
                    <button v-on:click="removeItem(option)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        list: Array,
        selected: null,
        selectedParent: null,
    },
    data() {
        return {
			layoutUrl: 'stages/layout',        
        };
    },
    methods: {
        selectItem(item) {
            this.$emit('select', item.id);
        },
		layoutItem(item) {  
		  //axios.get(this.layoutUrl + '/' + item.id);
			window.open(this.layoutUrl+'/'+item.id, '_blank');
		},
        editItem(item) {
            this.$emit('edit', item);
        },
        removeItem(item) {
            if(confirm('Are you sure you want to remove this?')) {
                axios
                    .delete(this.stageUrl + '/' + item.id)
                    .then(res => {
                        this.$emit('remove', res.data);
                    });
            }
        },
    },
    computed: {
        stageUrl: function() {
            return '/event/venues/' + this.selectedParent + '/stages';
        }               
    }
}
</script>